module.exports = __webpack_public_path__ + "img/6973d13.jpg";